import type { Profile } from "@/domain/types";
import cvarsText from "./Ed_Destiny2.cvars.xml" with { type: "text" };
import { ingestDestiny } from "./ingest";

// The Edennil Source's Destiny 2 setup, recovered from the maintainer's real cvars.xml and
// board-bound to the ReCore FPS board layer: selecting it pins ReCore + recore-v3-layer-4.
// Projection stays twin-paint: a token the layer emits from two keys paints both (PTT "8" lands on
// the Escape-position key AND the number row). Built through the shared Destiny
// ingest, same as the stock Default - it differs only by this cvars.xml and the pin.
//
// Movement steers the Vehicle Context too and takes the cap with priority, so the ingest surfaces any
// overload automatically as a shadow on the survivor - no hand-authored annotate needed. With the
// maintainer's corrected cvars the only vehicle overload left is the benign twin on his left thumb
// (Ctrl): Jump (steering) over Vehicle Jump, both "jump", so movement wins the cap and carries
// Vehicle Jump as its shadow.
// The earlier weakness is gone - the corrected file moved Secondary Fire to G (off Ctrl and off C),
// Exit Vehicle to Alt (off Z), and Brake to Shift (off A), so those keys read clean and C: Back no
// longer shadows anything. The note is computed from the file, so any later change re-derives. Verified
// bind-by-bind vs the cvars file + the maintainer's screenshots (docs/destiny-hotkeys/).
export const edennilDestiny: Profile = {
  ...ingestDestiny(cvarsText, {
    id: "edennil",
    name: "Edennil",
    pin: { keyboard: "recore-v3", layer: "recore-v3-layer-4" },
  }),
  // the maintainer's real cvars.xml, offered for download verbatim (see the Default for why it is
  // attached here at assembly time rather than recovered from the ingested Profile).
  download: { fileName: "Ed_Destiny2.cvars.xml", text: cvarsText },
};
